import api from "./api";


const register=(apiParams) =>{
	
	const apiPath = `/authentication/register`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("saveuser " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}

const registerWithToken=(apiParams,token) =>{
	
	const apiPath = `/authentication/register`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("saveuser " + apiPath,token);
	let url=apiPath;

	
	let data=apiParams;


	api.defaults.headers = {'Authorization': `Bearer ${token}`}
	const response = api.post(url ,data);
	return response;
}



const signin = async (username, password) => {


	let apiParams={ username, password };

	const apiPath = `/authentication/signin`;
	console.log("new auth");
	const response = await api
		.post(apiPath,apiParams);
	return response;
};


const signout = async (username) => {
	let _username = encodeURIComponent(username);
	const apiPath = `/authentication/signout?username=${_username}`;
	const response = await api
		.post(apiPath);
	return response;
};


const forgotpassword = async (username) => {
	let _username = encodeURIComponent(username);
	const apiPath = `/authentication/forgotpassword?username=${_username}`;
	const response = await api
		.post(apiPath);
	return response;
};

const forgotPasswordVerify = async (apiParams) => {

	const apiPath = `/authentication/forgotpasswordverify`;

	apiParams={ ...apiParams, tenantId: 1 };

	//console.log("forgotpasswordverify " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}


const sendSmsToken = async (username) => {
	let _username = encodeURIComponent(username);

	const apiPath = `/authentication/otpsms?username=${_username}`;
	const response = await api
		.post(apiPath);
	return response;
};

const AuthenticationService = {
	register,
	signin,
	forgotpassword,
	forgotPasswordVerify,
	sendSmsToken,
	signout,
	registerWithToken

};

export default AuthenticationService;
